import React from 'react';
import {accessToken__, refreshToken__, tokenType__, useAuthorizationDispatch, useAuthorizationStore} from '../contexts/Authorization';
import {businessContractId__, scanContractId__, useContractDispatch} from '../contexts/contract';

const RAZZLE_APP_ACCOUNTS = process.env.RAZZLE_APP_ACCOUNTS;
const RAZZLE_APP_SIGNOUT = process.env.RAZZLE_APP_SIGNOUT;

const LogOut = () => {
    const authorizationDispatch = useAuthorizationDispatch();
    const authorizationStore = useAuthorizationStore();
    const contractDispatch = useContractDispatch();
    React.useEffect(() => {
        authorizationStore.remove(tokenType__);
        authorizationStore.remove(accessToken__);
        authorizationStore.remove(refreshToken__);
        authorizationStore.remove(businessContractId__);
        authorizationStore.remove(scanContractId__);
        authorizationDispatch();
        contractDispatch();
        setTimeout(
            () => window.location.href =
                RAZZLE_APP_ACCOUNTS + '/' + RAZZLE_APP_SIGNOUT + '.html?cache=0&continue='
                + encodeURIComponent(document.location.origin + document.location.search),
            500
        );
    }, []);
    return (
        <div>
            Loading...
        </div>
    );
}

export default React.memo(LogOut);
